import { combineReducers } from 'redux'
import {
  LOADING_SIZES,
  LOADING_SIZES_SUCCEEDED,
  LOADING_SIZES_FAILED
} from 'redux/actionTypes'

const byId = (state = {}, action) => {
  switch (action.type) {
    case LOADING_SIZES_SUCCEEDED:
      return {
        ...state,
        ...action.payload.entities.sizes
      }
    default:
      return state
  }
}

const isFetching = (state = false, action) => {
  switch (action.type) {
    case LOADING_SIZES:
      return true
    case LOADING_SIZES_SUCCEEDED:
    case LOADING_SIZES_FAILED:
      return false
    default:
      return state
  }
}

const sizesReducer = combineReducers({
  byId, isFetching
})

export default sizesReducer

// selectors

export const getIsFetching = (state) => state.isFetching

export const getSize = (state, id) => state.byId[id] || {}

export const getSizes = (state) => {
  let ids = Object.keys(state.byId)
  // sort the ids in desceding order
  ids.sort((a, b) => Number(b) - Number(a))
  return ids.map(id => getSize(state, id))
}



// WEBPACK FOOTER //
// ./src/redux/reducers/sizes.js